import React, { useState } from "react";
import { Redirect } from "@reach/router";
import { ReactSession } from 'react-client-session';

const Logout = (props) => {
    ReactSession.remove("username");
    ReactSession.remove("userId");
    ReactSession.remove("userImg");
    return (
        <Redirect to="/" />
    )
};

export default Logout;
